const REGION_MAP = {
  US: 'us',
  default: 'international'
};

function getStoredRegion() {
  try { return localStorage.getItem('selected_region'); }
  catch(e) { return null; }
}

function setStoredRegion(region) {
  try {
    localStorage.setItem('selected_region', region);
    document.cookie = `selected_region=${region}; path=/; max-age=31536000`;
  } catch(e){}
}

function setRejectedRegion(region) {
  try {
    localStorage.setItem('region_rejected', region);
  } catch(e){}
}

async function detectCountry() {
  try {
    const res = await fetch('/browsing_context_suggestions.json');
    const data = await res.json();

    const iso = data?.detected_values?.country?.handle;
    if (iso) return iso.toUpperCase();

    return null;
  } catch (e) {
    return null;
  }
}

function getCurrentRegion() {
  const path = window.location.pathname;
  return path.startsWith('/en-international') ? 'international' : 'us';
}

function redirectToRegion(region, href = undefined) {
  let path = window.location.pathname + window.location.search + window.location.hash;
  
  if(href){
    path = href;
  }

  /*
  if(href.includes('/en-international') && href.includes('webinars')){
    console.log(`href: ${href}, path: ${path}`);
    return;
  }
    */
  if (region === 'us') {
    if (path.startsWith('/en-international')) {
      window.location.href = path.replace('/en-international', '') || '/';
    }
  } else {
    if (!path.startsWith('/en-international')) {
      window.location.href = '/en-international' + path;
    }
  }
}

async function controlFooterRegions() {
  const footerRegionSelector = $('.region-choose-link');
  
}

const toggleRegionCardAnimation = (direction, selector_id) => {
  const selector = document.getElementById(selector_id);
  gsap.fromTo(selector, {
    opacity: direction ? 0 : 1,
  }, {
    opacity: direction ? 1 : 0,
    duration: 0.833,
    ease: 'pageInEasing',
    onStart: () => direction ? selector.style.display = 'flex' : false,
    onComplete: () => !direction ? selector.style.display = 'none' : false,
  })
}

async function initRegionSelector() {
  const manual = getStoredRegion();
  const current = getCurrentRegion();
  if (manual) {
    if(manual != current){
      redirectToRegion(manual);
    }
    return
  };
  if(manual === null) {
    redirectToRegion('us');
  }

  const countryCode = await detectCountry();
  const desired = REGION_MAP[countryCode] || REGION_MAP.default;

  if (current === desired || localStorage.getItem('region_rejected') === desired) {
    //setStoredRegion(current);
    return
  };

  $(window).on('heroReady', function(){
    //if (selector) selector.style.display = 'flex';
    toggleRegionCardAnimation(true, 'region-selector');

    document.getElementById('region-selector-accept').addEventListener('click', () => {
      setStoredRegion(desired);
      redirectToRegion(desired);
    });

    document.getElementById('region-selector-close').addEventListener('click', () => {
      setRejectedRegion(desired);
      toggleRegionCardAnimation(false, 'region-selector');
    });
  })
}

const initRegionChange = (region, href) => {
  console.log(region, href)
  const current = getCurrentRegion();
  toggleRegionCardAnimation(true, 'region-changer');

  $('.region-changer-accept').on('click', function(){
    setStoredRegion(region);
    toggleRegionCardAnimation(false,'region-changer');
    if(window.location.href == href){
      if (region === 'us') {
        let path = window.location.pathname + window.location.search + window.location.hash;
        if (path.startsWith('/en-international')) {
          window.location.href = path.replace('/en-international', '') || '/';
        }
      }
    } else {
      redirectToRegion(region, href);
    }
  })

  $('.region-changer-close').on('click', function(){
    if(window.location.href == href){
      redirectToRegion(current, '/')
    } else {
      toggleRegionCardAnimation(false,'region-changer');
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initRegionSelector();
  document.querySelectorAll('.region-choose [data-region]').forEach(btn => {
    btn.addEventListener('click', () => {
      const region = btn.dataset.region;
      setStoredRegion(region);
      redirectToRegion(region);
    });
  });
});
